module.exports = __webpack_public_path__ + "static/media/contentBg@2x.c77154c9.png";